import { SEOToolsQueryProvider } from '@corefront/seo-tools';
import { withSEOContent } from '../../hocs/withSEOContent';
import { queryClient } from '../../services/queryClient';

const SEOQueryProvider = ({ children }) => (
  <SEOToolsQueryProvider queryClient={queryClient}>
    {children}
  </SEOToolsQueryProvider>
);

export default withSEOContent(SEOQueryProvider);
